import request, { IWorkspaceResponse } from '/@/api/http/request'
import { DeviceCmd, DeviceCmdItemAction } from '/@/types/device-cmd'

const CMD_API_PREFIX = '/control/api/v1'

export interface SendCmdParams {
  dock_sn: string,
  device_cmd: DeviceCmd
}

export interface PostSendCmdBody {
  action: DeviceCmdItemAction
}
/**
 * @param params
 * @returns
 */

export async function postSendCmd (params: SendCmdParams, body?: PostSendCmdBody): Promise<IWorkspaceResponse<{}>> {
  const postBody = body || {}
  const resp = await request.post(`${CMD_API_PREFIX}/devices/${params.dock_sn}/jobs/${params.device_cmd}`, {
    ...postBody
  })
  return resp.data
}
